// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3EFON","form":"styles_form__3-yNh"};